import type { ExportColumnKeys } from "@/modules/export";
import type { PermissionsColumnKey } from "./permissions.types";

/** Coluna da tela de Permissões → chave do core na exportação (`null`: fora do arquivo). */
export const PERMISSIONS_EXPORT_COLUMN_KEYS: ExportColumnKeys<PermissionsColumnKey> = {
  codigo: "claim",
  nome: "rotulo",
  descricao: "descricao",
  acoes: null,
};
